import { render } from "./ErrorLabel.vue?vue&type=template&id=4409d5d0"
import script from "./ErrorLabel.vue?vue&type=script&lang=js"
export * from "./ErrorLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__